import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import it from './locales/it/translation.json';
import de from './locales/de/translation.json';
import pt from './locales/pt/translation.json';
import zh from './locales/zh/translation.json';
import ja from './locales/ja/translation.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  it: { translation: it },
  de: { translation: de },
  pt: { translation: pt },
  zh: { translation: zh },
  ja: { translation: ja },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['en', 'es', 'it', 'de', 'pt', 'zh', 'ja'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

export default i18n;
